import { Icon, Icons } from "../../elements/Icon";
import { SocialMediaLinks } from "./components/SocialMediaLinks";
import { styles } from "./ContactCard.style";

export interface ContactCardProps {
  title: string;
  name: string;
  jobTitle: string;
  emailLink: string;
  emailText?: string;
  featuredImage?: string;
  followHeadline?: string;
  socials?: {
    facebook?: string;
    linkedin?: string;
    twitter?: string;
  };
}

export const ContactCard = (props: ContactCardProps) => {
  const { title, name, jobTitle, emailLink, emailText, featuredImage, followHeadline, socials } = props;
  return (
    <div className={styles.contactCard()}>
      {featuredImage && (
        <div className={styles.featuredImage()}>
          <div className={styles.featuredImageWrapper()}>
            {featuredImage && (
              <img src={`${featuredImage}`} alt={name} loading="lazy" decoding="async" fetchPriority="low" />
            )}
          </div>
        </div>
      )}
      <div className={styles.backgroundWrapper()}>
        <h2 data-testid="contact-title">{title}</h2>
        <div className={styles.contentWrapper()}>
          <div className={styles.contactWrapper()}>
            <span>{name}</span>
            <span>{jobTitle}</span>
            <div className={styles.emailWrapper()}>
              <Icon icon={Icons.mailBlue} />
              {emailText || emailLink}
            </div>
          </div>
          <div className={styles.followUsWrapper()}>
            <span>{followHeadline}</span>
            <SocialMediaLinks {...socials} />
          </div>
        </div>
      </div>
    </div>
  );
};
